import type { DatapointResponseVersionSnapshotDto } from "~/gen/api/types/DatapointResponseVersionSnapshotDto.ts"

type ResolveAuthorOrganizationLabelInput = {
  readonly authorOrganizationId: string
  readonly snapshot: DatapointResponseVersionSnapshotDto
  readonly currentOrganizationId: string | undefined
  readonly currentOrganizationName: string | undefined
}

export const resolveAuthorOrganizationLabel = ({
  authorOrganizationId,
  snapshot,
  currentOrganizationId,
  currentOrganizationName,
}: ResolveAuthorOrganizationLabelInput): string | null => {
  if (
    currentOrganizationId !== undefined &&
    authorOrganizationId === currentOrganizationId &&
    currentOrganizationName
  ) {
    return currentOrganizationName
  }

  if (snapshot.authorOrganization.name) {
    return snapshot.authorOrganization.name
  }

  return null
}

export const shortOrganizationId = (organizationId: string): string =>
  organizationId.slice(0, 8)
